import React from 'react'
import CopyToClipboardUI from '../../../widgets/output/CopyToClipboardUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
const getDisplayAmount = (loan) => {
  if (loan.status === 'disbursed') {
    return loan.disbursement && loan.disbursement.amountF2
  }
  if (loan.status === 'sanctioned') {
    return loan.sanction && loan.sanction.amountF2
  }
  if (loan.status === 'term_sheet') {
    return loan.termSheet && loan.termSheet.amountF2
  }
  if (loan.status === 'requested') {
    return loan.loanRequest && loan.loanRequest.amountF2
  }
  return null
}

const DocumentRepositoryLoanListUI = ({ context, loanList, onRowClick, onRefreshClick,
  onCopyToClipboard, copyToClipboardText, onDownloadAllClick, downloadingAll
}) =>
  <div className='su_loan_lst'>
    <LRTableActionsUI location='top'
      left={
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
          <span className='g_m_left_100 g_large'><b>Document Repository</b></span>
        </div>
      }
      right={
        <span className='g_link' onClick={onDownloadAllClick}>
          {downloadingAll ? 'Downloading...' : 'Download All'}
        </span>
      }
    />

    <div className='g_flex_h g_m_bottom_50'>
      <span>{loanList.length} loan{loanList.length == 1 ? '' : 's'} displayed</span>
    </div>

    <LRTableBodyUI>
      {
        loanList.map((loan, i) =>
          <LRTableRowUI
            key={i}
            context={context}
            left={
              <div className='g_flex_v'>
                <span><b>{loan.loanName}</b> {getDisplayAmount(loan) && `(${getDisplayAmount(loan)})`}</span>
                <span className='g_flex_h g_muted g_flex_left'>
                  <span className='g_m_right_100'>{loan.parentLRN ? loan.parentLRN + ' > ' + loan.loanRefNum : loan.loanRefNum}</span>
                  <CopyToClipboardUI text={loan.loanId}
                    onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
                  />
                  {
                    loan.parentLoanId &&
                    <a className='g_link g_m_left_100' href={`/su/documentRepository/loans/${loan.parentLoanId}`}
                      onClick={(e) => e.stopPropagation()}>
                      Go to Parent Loan
                    </a>
                  }
                </span>
              </div>
            }
            right={<BadgeUI label={loan.status} />}
            onClick={loan.parentLoanId ? undefined : onRowClick}
            rowId={loan.loanId}
          />
        )
      }
    </LRTableBodyUI>
  </div>

export default DocumentRepositoryLoanListUI